import React from 'react';
import { Dropdown, InlineSelect } from '~/native-ui/Dropdown';

import PropTypes from 'prop-types';


export class YesNoSelect extends React.Component {
    static propTypes = {
        isInline: PropTypes.bool,
        value: PropTypes.bool,
    };

    getSource = () => {
        let { trans } = this.props;

        return [
            { value: true, label: trans('yes') },
            { value: false, label: trans('no') },
        ].filter((v) => v);
    };

    handleSelect = (value) => {
        this.props.onChange(value);
    };

    render() {
        const Component = this.props.isInline === true ? InlineSelect : Dropdown
        return (
            <Component
                label={this.props.title}
                tooltip={this.props.tooltip}
                value={this.props.value === null ? null : this.props.value}
                source={this.getSource()}
                onChange={this.handleSelect}
            />
        );
    }
}
